import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { useRequireAuth } from '@/hooks/useAuth'

/**
 * Main layout wrapper component.
 *
 * Provides the common structure for all pages:
 * - Header with navigation
 * - Main content area
 * - Ensures user is authenticated
 *
 * The Outlet component from React Router renders the matched child route.
 */
export function Layout() {
  // Require authentication for all v2 pages
  const { isAuthenticated } = useRequireAuth()

  // Show loading state while checking auth
  if (!isAuthenticated) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="text-center">
          <div className="mb-4 h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
          <p className="text-text-light">Checking authentication...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="h-screen-dynamic flex flex-col overflow-hidden bg-background">
      {/* Header */}
      <Header />

      {/* Main content - takes remaining height */}
      <main className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <Outlet />
      </main>
    </div>
  )
}
